import { createContext, useState } from 'react'

const GeneralContext = createContext()

export const GeneralProvider = ({ children }) => {
   const [currentTab, setCurrentTab] = useState('Profile') //possible values = Home Profile Messages Friends Notifications GuestPage
   const [guestPageData, setGuestPageData] = useState({
      name: "",
      description: "",
      imageSrc: "",
      username: "",
      id: "",
      tags: {},
   })

   const [showFullSize, setShowFullSize] = useState(true)

   function getWindowDimensions() {
      const { innerWidth: width, innerHeight: height } = window
      return {
         width,
         height,
      }
   }

   //Function that would return user's friends, description, name, blocked users, pending friends
   const get_userInfo = async (user) => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users' +
            '?attributes=%7B%0A%20%20%22path%22%3A%20%22username%22%2C%0A%20%20%22equals%22%3A%20%22' +
            user +
            '%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               // returns user object with data stored in that user
               console.log(result[0][0])
               return result[0][0]
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const get_current_friends = async () => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
         '/connections?attributes=%7B%0A%20%20%22path%22%3A%20%22status%22%2C%0A%20%20%22equals%22%3A%20%22accepted%22%0A%7D&anyUserID=' + sessionStorage.getItem('user'),
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result) {
                  // returns all accepted friends for user in array of user objects
                  //setFriendsData({ ...friendsData, ['current']: result[0] })
                  return result[0]
               }
            },
            (error) => {
               console.log('error: no friends found')
            }
         )
   }

   const get_current_blocked = async () => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            sessionStorage.getItem('user') +
            '&attributes=%7B%0A%20%20%22path%22%3A%20%22status%22%2C%0A%20%20%22equals%22%3A%20%22blocked%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result) {
                  // returns all blocked friends for user in array of user objects
                  //setFriendsData({ ...friendsData, ['blocked']: result[0] })
                  return result[0]
               }
            },
            (error) => {
               console.log('error: no friends found')
            }
         )
   }

   const get_current_pending = async () => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/connections' +
            '?fromUserID=' +
            sessionStorage.getItem('user') +
            '&attributes=%7B%0A%20%20%22path%22%3A%20%22status%22%2C%0A%20%20%22equals%22%3A%20%22pending%22%0A%7D',
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result) {
                  // returns all pending friends for user in array of user objects
                  //setFriendsData({ ...friendsData, ['pending']: result[0] })
                  return result[0]
               }
            },
            (error) => {
               console.log('error: no friends found pending')
            }
         )
   }

   const get_activity = async (activityID) => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts/' +
            activityID,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               if (result) {
                  // returns activity and its data
                  //console.log(result)
                  return result
               }
            },
            (error) => {
               console.log('error: no activity found')
            }
         )
   }

   const get_userInfoByID = async (userID) => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/users/' +
            userID,
         {
            method: 'GET',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               // returns user object with data stored in that user
               //console.log(result)
               return result
            }
         })
         .catch((error) => {
            console.error('Error:', error)
         })
   }

   const [showParticipants, setShowParticipants] = useState(false)
   const [participantsHome, setParticipantsHome] = useState([])

   const [showComments, setShowComments] = useState(false)
   const [comments, setComments] = useState([])
   const [commentActivityID, setCommentActivityID] = useState(null)
   const [currentComment, setCurrentComment] = useState('')
   const [ignorePointer, setIgnorePointer] = useState(false)
   const [showSemiSize, setShowSemiSize] = useState(false)
   const [hideOptions, setHideOptions] = useState(false)
   

   return (
      <GeneralContext.Provider
         value={{
            currentTab,
            guestPageData,
            showParticipants,
            participantsHome,
            showFullSize, 
            ignorePointer,
            showSemiSize, 
            hideOptions, 
            setHideOptions,
            setShowSemiSize,
            setIgnorePointer,
            setShowFullSize,
            setParticipantsHome,
            setShowParticipants,
            setCurrentTab,
            get_userInfo,
            get_current_blocked,
            get_current_friends,
            get_current_pending,
            get_activity,
            get_userInfoByID,
            setGuestPageData,
            showComments,
            setShowComments,
            comments,
            setComments,
            commentActivityID,
            currentComment, 
            setCurrentComment,
            setCommentActivityID,
            getWindowDimensions,
         }}
      >
         {children}
      </GeneralContext.Provider>
   )
}

export default GeneralContext
